// vuex / store / getters
export default {
  userEmail: state => {
    return state.user.email
  }
}
